namespace TR {
    export class VoucherModalService {
        private domain = TRPCONFIG.Domain;
        private apiUrl = 'api/hotels/modals';

        constructor (
            private $http: ng.IHttpService,
            private cookieService) {
        }

        getVoucherInfo (options = {}) {
            const bd4userId = this.cookieService.get('bd4ti') || '';
            return this.$http.post(
                `${this.apiUrl}/query/?domainId=${this.domain.DomainId}&bd4userId=${bd4userId}`,
                options
            ).then(response => bd4userId ? response.data : {});
        }
    }

    angular.module('TR').service('voucherModalService', VoucherModalService);
}
